import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import CardSquare from '@/common/components/cardSquare/CardSquare';
import SubstitutionParts from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/SubstitutionParts';
import {
  default as VisitFormIcon,
  default as VisitInformation,
} from '@/modules/adjusterReportModules/IncidentParticipants/assets/iconComponents/visitInformation';
import { INITIAL_VISIT_ADJUSTER_LINKS } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import { ExpertEntryTabsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQuery.type';
import { getExpertTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getExpertTabs/getExpertTabsQueryOption';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Grid } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const InitialVisitExpertEntryTabs = () => {
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const { data, isPending } = useQuery(
    getExpertTabsQueryOptions({
      id: +id!,
      damaged_id: +damagedId!,
      source: 'pwa',
      type: 'initial',
    }),
  );

  const handleNavigateClick = (item: ExpertEntryTabsQueryResponseType) => {
    let path = '';
    if (item?.name === 'accessory') {
      path = item?.editable
        ? INITIAL_VISIT_ADJUSTER_LINKS.INITIAL_VISIT_ACCESSORY(+id!)
        : INITIAL_VISIT_ADJUSTER_LINKS.INITIAL_VISIT_ACCESSORY_SHOW(+id!);
    }
    if (item?.name === 'visit_form') {
      path = item?.editable
        ? INITIAL_VISIT_ADJUSTER_LINKS.INITIAL_VISIT_FORM(+id!)
        : INITIAL_VISIT_ADJUSTER_LINKS.INITIAL_VISIT_FORM_SHOW(+id!);
    }
    if (item?.name === 'visit_information') {
      path = item?.editable
        ? INITIAL_VISIT_ADJUSTER_LINKS.INITIAL_VISIT_INFORMATION(+id!)
        : INITIAL_VISIT_ADJUSTER_LINKS.SHOW_INITIAL_VISIT_INFORMATION(+id!);
    }
    return navigate(path);
  };

  return (
    <>
      {isPending ? (
        <Box
          mt="56px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box mt="56px">
          <Grid
            className={css({
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '6px',
            })}
          >
            {data?.map((item) => (
              <Box key={item.name}>
                <CardSquare
                  disabled={item?.is_card_active}
                  title={item?.fa_name}
                  onClick={() => handleNavigateClick(item)}
                  renderIcon={() => {
                    switch (item.name) {
                      case 'visit_information':
                        return (
                          <CustomIcon
                            backgroundColor={
                              item?.is_card_active
                                ? token('colors.orange-3')
                                : token('colors.gray-3')
                            }
                            width="42px"
                            height="42px"
                          >
                            <VisitInformation
                              fill={
                                item?.is_card_active
                                  ? token('colors.orange-3')
                                  : token('colors.gray-3')
                              }
                              stroke={
                                item?.is_card_active
                                  ? token('colors.orange')
                                  : token('colors.gray')
                              }
                            />
                          </CustomIcon>
                        );
                      case 'accessory':
                        return (
                          <SubstitutionParts
                            fill={
                              item?.is_card_active
                                ? token('colors.green-4')
                                : token('colors.gray-3')
                            }
                            stroke={
                              item?.is_card_active
                                ? token('colors.green')
                                : token('colors.gray')
                            }
                          />
                        );
                      case 'visit_form':
                        return (
                          <VisitFormIcon
                            fill={
                              item?.is_card_active
                                ? token('colors.purple-6')
                                : token('colors.gray-3')
                            }
                            stroke={
                              item?.is_card_active
                                ? token('colors.purple-primary')
                                : token('colors.gray')
                            }
                          />
                        );
                      default:
                        return null;
                    }
                  }}
                />
              </Box>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};
export default InitialVisitExpertEntryTabs;
